import { Component, computed, inject, input, model, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCard, MatCardContent, MatCardTitle } from '@angular/material/card';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { dsEnums } from '@vectronic/openApi-admin';
import { AbstractScheduleService } from '../../services/abstract-schedule.service';
import { ScheduleServices } from '../../services/schedule.service';
import { CalendarDayViewBeaconComponent } from '../calendar-day-view-beacon/calendar-day-view-beacon.component';
import { CalendarDayViewComponent } from '../calendar-day-view/calendar-day-view.component';
import { CalendarMonthViewComponent } from '../calendar-month-view/calendar-month-view.component';
import { CalendarYearViewComponent } from '../calendar-year-view/calendar-year-view.component';

@Component({
  selector: 'rc-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
  imports: [
    MatCard,
    MatCardTitle,
    MatDivider,
    MatCardContent,
    MatButtonModule,
    MatIcon,
    MatTooltip,
    CalendarDayViewComponent,
    CalendarDayViewBeaconComponent,
    CalendarMonthViewComponent,
    CalendarYearViewComponent,
  ],
})
export class CalendarComponent {
  private scheduleServices = inject(ScheduleServices);

  scheduleType = input<dsEnums.ScheduleType>();

  selectedDate = signal(new Date());
  view = signal<'year' | 'month' | 'day'>('year');
  showPreview = model(false);

  isVHF = computed(() => this.scheduleType() === 'VHF');

  showPreviewLabel = computed(() => (this.showPreview() ? 'Hide preview' : 'Show preview'));

  scheduleService = computed<AbstractScheduleService>(() => {
    if (!this.scheduleType()) return undefined;
    return this.scheduleServices[this.scheduleType()];
  });

  onMonthChange(date: Date) {
    this.selectedDate.set(date);
    this.view.set('month');
  }

  onDayChange(date: Date) {
    this.selectedDate.set(date);
    this.view.set('day');
  }

  onYearChange(date: Date) {
    this.selectedDate.set(date);
  }
}
